import { Injectable } from '@angular/core';
import { HttpClientService } from '../common/http-client.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';

@Injectable()
export class PrivacyPolicyService {
  constructor(private http: HttpClientService) { }

  /**
   * Get Privacy Policy data from API
   * This is a dummy API call that returns mock data
   * In production, replace this with actual API endpoint
   */
  getPrivacyPolicyData(): Observable<any> {
    // Simulate API call with delay
    // In production, replace this with: return this.http.get('privacy-policy/data', null, 2);
    
    const mockResponse = {
      status: 'success',
      message: 'Privacy policy data retrieved successfully',
      data: {
        title: 'AFROPAY PRIVACY POLICY',
        lastUpdated: 'Effective Date: 8th December 2025',
        introduction: 'AfroPay ("AfroPay", "we", "our", "us") is a mobile wallet and digital financial service operated by Afro Pay Company Ltd, a licensed financial institution regulated by the Central Bank of The Gambia (CBG). Your privacy is important to us. This Privacy Policy explains: a. What personal data we collect b. How we collect it c. Why we collect and process it d. How we store, share, and protect your data e. Your rights under Gambian law f. Our obligations under: i. The Laws of The Gambia ii. The Anti-Money Laundering and Combating of Terrorism Act (AML/CTF Act) iii. Central Bank of The Gambia regulatory requirements iv. International remittance compliance frameworks By using AfroPay, you consent to the practices described in this Policy. This Policy applies to: i. Customers using AfroPay ii. Agents performing cash-in/cash-out services iii. Merchants accepting AfroPay payments iv. Agent and merchant staff v. Prospective users vi. Anyone interacting with AfroPay services (Collectively, "users").',
        sections: [
          {
            title: 'Personal Data We Collect',
            content: 'We collect the following categories of personal data.',
            points: [
              'A. Identity & KYC Information - Required to comply with CBG and AML/CTF regulations: i. Full name ii. Date of birth iii. Nationality iv. National ID, passport, or other government-issued identification (including number, photo, DOB) v. Residential address vi. Phone number & email vii. Biometric verification data (selfie/face scan), when required viii. Signature (digital or physical) ix. Agent/merchant registration documents x. Proof of address',
              'B. Account & Financial Information - i. Wallet ID ii. Account balances iii. Transaction history iv. Beneficiary details v. Linked bank account or card details (tokenized where applicable) vi. Remittance information vii. Agent and merchant transaction logs viii. Payment receipts and statements',
              'C. Device & Technical Data - Collected automatically through the AfroPay app: i. IP address ii. Device identifiers iii. Operating system & version iv. Network information v. App usage logs vi. Crash reports vii. Cookies or similar technologies',
              'D. Location Information - i. Approximate location for fraud detection and compliance ii. Location of agent transactions (required by CBG monitoring rules) (We do not track continuous GPS location.)',
              'E. Communications & Interactions - i. Customer support messages ii. Emails, complaints, and enquiries iii. Call recordings (where applicable) iv. Feedback provided through the app',
              'F. Data From Third Parties - We may receive personal data from: i. Banks (for bank-to-wallet/wallet-to-bank transfers) ii. Mobile network operators iii. International remittance partners iv. Background check and identity verification partners v. Agents and merchants vi. Publicly available sources vii. Law enforcement, FIU, and regulators where required'
            ]
          },
          {
            title: 'How We Use Your Personal Data',
            content: 'We process your data to:',
            points: [
              'A. Operate Your AfroPay Wallet - i. Create and maintain your wallet account ii. Process transfers, deposits, withdrawals, merchant payments, and both inbound and outbound remittances. iii. Authenticate and verify your identity iv. Generate receipts, confirmations, and notifications v. Provide customer support',
              'B. Comply With Legal and Regulatory Obligations - Required by: i. CBG regulations ii. AML/CTF Act iii. FIU reporting requirements iv. Sanctions screening rules v. Remittance licensing and settlement obligations Includes: i. KYC verification ii. Ongoing monitoring iii. Suspicious activity reporting (STR/SAR) iv. Transaction monitoring v. Mandatory record keeping',
              'C. Prevent Fraud and Enhance Security - i. Detect suspicious or prohibited activity ii. Verify users and devices iii. Prevent account takeover or unauthorized access iv. Secure digital infrastructure',
              'D. Improve AfroPay Services - i. Fix technical issues ii. Improve app features iii. Conduct analytics and service optimization iv. Machine learning for fraud detection (We do not use data for automated decision-making that significantly affects you.)',
              'E. Marketing & Communication - With your consent where applicable: i. Send promotional messages ii. Notify you about new products and updates iii. Conduct surveys and research You may opt out at any time.',
              'F. Legal Claims, Disputes & Investigations - i. Handle complaints ii. Respond to legal demands iii. Protect AfroPay\'s rights and interests'
            ]
          },
          {
            title: 'Legal Basis for Processing',
            content: 'We process your data under:',
            points: [
              'i. Consent (e.g., marketing, app permissions)',
              'ii. Contractual necessity (using AfroPay requires processing)',
              'iii. Legal obligations (CBG, AML/CTF, FIU, tax laws)',
              'iv. Legitimate interests (fraud prevention, service enhancement)'
            ]
          },
          {
            title: 'Data Storage & Cross-Border Transfers',
            content: 'AfroPay uses secure cloud hosting, which may be located in:',
            points: [
              'i. The European Union or United Kingdom',
              'ii. The United States',
              'iii. Other jurisdictions with adequate protections',
              'Cross-Border Protections - We ensure: i. Encryption of data in transit and storage ii. Confidentiality obligations for all processors iii. Access only by authorized, vetted personnel iv. Compliance with relevant regulatory approvals (e.g., CBG notification) By using AfroPay, you consent to international data transfers under these safeguards.'
            ]
          },
          {
            title: 'Who We Share Your Data With',
            content: 'We share data only when necessary.',
            points: [
              'A. Regulated Financial Institutions & Partners - i. International remittance partners ii. Settlement banks iii. Payment processors iv. Mobile network operators v. Merchant platforms',
              'B. Regulators and Government Authorities - i. Central Bank of The Gambia ii. Financial Intelligence Unit iii. Law enforcement agencies iv. Courts (when served with lawful orders)',
              'C. Technical and Operational Providers - i. Cloud hosting providers ii. Fraud detection and risk management services iii. SMS and email notification providers',
              'D. Other Users - Where required for transactions: i. The recipient may see your name or phone number ii. You may see sender information',
              'E. Professional Advisors - i. Lawyers, auditors, compliance specialists',
              'F. Business Transfers - If AfroPay undergoes a merger, acquisition, restructuring, or asset sale, user data may be transferred with appropriate safeguards.',
              'We do NOT sell personal data.'
            ]
          },
          {
            title: 'Data Security',
            content: 'We implement industry-standard security controls:',
            points: [
              'i. Encryption at rest and in transit',
              'ii. Multi-layer firewalls',
              'iii. Access controls & authentication',
              'iv. Segregation of duties',
              'v. Regular audits, penetration testing, and monitoring',
              'vi. Biometric or PIN login protection',
              'Users must keep their PIN and device secure.'
            ]
          },
          {
            title: 'Data Retention',
            content: 'We retain:',
            points: [
              'i. KYC data: minimum 5 years',
              'ii. Transaction data: minimum 5 years',
              'iii. Communications and logs: per regulatory and compliance requirements',
              'After mandatory retention periods, data is anonymized or securely deleted.'
            ]
          },
          {
            title: 'Children\'s Data',
            content: '',
            points: [
              'AfroPay is not intended for anyone under 18.',
              'We do not knowingly collect child data.'
            ]
          },
          {
            title: 'Data Breach Notification',
            content: 'If a data breach occurs that may affect your rights:',
            points: [
              'i. We will notify you promptly',
              'ii. We will notify CBG/FIU where required',
              'iii. We will take corrective measures'
            ]
          },
          {
            title: 'Cookies and Tracking Technologies',
            content: 'AfroPay uses:',
            points: [
              'i. Device identifiers',
              'ii. Analytics tools',
              'iii. Crash reporting systems',
              'These help us improve performance and security. We do not track users for advertising purposes outside AfroPay.'
            ]
          },
          {
            title: 'Updates to This Policy',
            content: 'We may update this Policy.',
            points: [
              'Material updates will be communicated via: i. In-app notices ii. Email iii. Website announcements',
              'Continued use of AfroPay constitutes acceptance of updates.'
            ]
          }
        ],
        yourRights: 'You may exercise the following rights:',
        rightsList: [
          'a. Access your personal data',
          'b. Request corrections',
          'c. Request deletion (where legally permitted)',
          'd. Withdraw consent (for marketing)',
          'e. Object to certain processing',
          'f. Request a copy of your data (data portability)',
          'g. Restrict processing in limited cases',
          'Requests may be sent to: info@afropaygm.com',
          'We will respond within the legally required timeframe.'
        ],
        dataSecurity: 'We implement industry-standard security controls: i. Encryption at rest and in transit ii. Multi-layer firewalls iii. Access controls & authentication iv. Segregation of duties v. Regular audits, penetration testing, and monitoring vi. Biometric or PIN login protection Users must keep their PIN and device secure.',
        contactEmail: 'info@afropaygm.com',
        contactPhone: '+220 314 9414',
        dataProtectionOfficer: ''
      }
    };

    // Simulate network delay (1 second)
    return Observable.of(mockResponse).delay(1000);
    
    // Production API call (uncomment when ready):
    // return this.http.get('privacy-policy/data', null, 2);
  }
}




// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/privacy-policy/privacy-policy.service.ts